import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./lang/messages";
import dateTimeFormats from "./lang/dateTimeFormats";
import numberFormats from "./lang/numberFormats";
import validateFr from "vee-validate/dist/locale/fr";
import validateEn from "vee-validate/dist/locale/en";
import VeeValidate from "vee-validate";

let lang = window.localStorage.getItem("lang")
  ? window.localStorage.getItem("lang")
  : "fr";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: lang, // set fallback locale
  messages, // set locale messages
  dateTimeFormats,
  numberFormats
});

Vue.use(VeeValidate, {
  i18nRootKey: "validations", // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: validateEn,
    fr: validateFr
  }
});

export default i18n;
